import * as React from 'react';
import * as firebase from 'firebase/app';
import { reduxForm, Field, InjectedFormProps } from 'redux-form';
import { Dispatch, connect } from 'react-redux';
import { AppState, Category, CollectionState } from 'src/store';
import { TextField } from 'redux-form-antd';
import { actions as toast } from 'src/toast';
import { actions as categoriesActions } from '../redux';
import { Button, Card, Row, Col } from 'antd';
import { push } from 'react-router-redux';
import { RouteComponentProps } from 'react-router';
import { actions } from '../redux';
import { required } from 'src/reduxFormAntd/validations';
import { TreeNode } from 'antd/lib/tree-select';
import { TreeSelectField } from 'src/reduxFormAntd';

const validateIDAsync = async ({ id }: FormData) => {
    if (id) {
        const ref = firebase.firestore().doc(`categories/${id}`);
        const doc = await ref.get();
        if (doc.exists) {
            throw { id: 'That ID is already taken' };
        }
    }
};

const formItemLayout = {
    labelCol: {
        xs: { span: 12 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 12 },
        sm: { span: 15 },
    },
};

const mapStateToProps = (appState: AppState, props: Props) => {
    const { categoryDetailState, categoriesState } = appState;
    const { match: { params: { id } } } = props;
    let initialValues: Partial<FormData> = { name: '' };
    if (id && categoryDetailState.status === 'loaded') {
        const {
            name,
            parentId
        } = categoryDetailState.data;

        initialValues = { name, parentId };
    }
    const loading = (categoryDetailState.status === 'loading');
    return {
        id,
        initialValues,
        loading,
        categoriesState
    };
};
const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        listen: (id: string | null) => {
            if (id) {
                dispatch(actions.listenDoc(id));
            }
            dispatch(categoriesActions.listenCollection());
        },
        unlisten: () => {
            dispatch(actions.unlistenDoc());
            dispatch(categoriesActions.unlistenCollection());
        }
    };
};

interface FormData {
    id?: string;
    name: string;
    parentId: string | null;
}

interface Props extends InjectedFormProps<FormData>, RouteComponentProps<{ id: string | null }> {
    id: string | null;
    loading: boolean;
    categoriesState: CollectionState<Category>;
    listen: (id: string | null) => void;
    unlisten: () => void;
}

function getTree(data: Category[], parentId: string | null): TreeNode[] {
    const categorys = data.filter(d => d.parentId === parentId).sort((a, b) => a.name.localeCompare(b.name));

    return categorys.map(i => {
        return {
            key: i.id.toString(),
            value: i.id.toString(),
            title: i.name,
            children: getTree(data, i.id),
        };
    });
}
const filterTreeNodeFn =// tslint:disable-next-line:no-any
    (inputValue: string, treeNode: any) =>
        treeNode.props.title.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
        
class CreateOrEditCategory extends React.Component<Props> {
    componentDidMount() {
        const { id, listen } = this.props;
        listen(id);

    }

    componentWillUnmount() {
        const { unlisten } = this.props;
        unlisten();
    }

    delete = async (values: FormData, dispatch: Dispatch<AppState>) => {
        const { id } = this.props;
        const ref = firebase.firestore().collection('categories');
        if (id) {
            const doc = ref.doc(id)
            await doc.delete()
            dispatch(toast.success('Category is deleted successfully.'));
            dispatch(push('/categories'));
        }
    }

    submit = async ({ id, ...values }: FormData, dispatch: Dispatch<AppState>) => {

        const addCategory = firebase.functions().httpsCallable('addCategory');
        await addCategory({
            id: id || this.props.id,
            ...values,
        });
        dispatch(toast.success('Cateogry is added successfully.'));
        dispatch(push('/categories'));
    }

    render() {
        const { handleSubmit, submitting, loading, id, categoriesState } = this.props;

        const treeData = getTree(
            categoriesState.status === 'loaded' ?
                categoriesState.data : [],
            null
        );

        return (
            <Card
                loading={loading}
                title={`${id ? 'Edit' : 'Create'} Category`}
                bordered={true}
                bodyStyle={{ padding: 0 }}
            >
                <form onSubmit={handleSubmit(this.submit)} className="ant-form ant-form-horizontal code-box">
                    <section className="last">
                        <Row>
                            <Col span={12}>
                                {/* <CategoryTreeSelect
                                    name="parentId"
                                    label="Parent Category"
                                    placeholder="Parent Category"
                                    {...formItemLayout}
                                    multiple={false}
                                    categoriesState={categoriesState}
                                /> */}
                                <Field
                                    name="parentId"
                                    label="Parent Category"
                                    placeholder="Parent Category"
                                    {...formItemLayout}
                                    component={TreeSelectField}
                                    treeSelectProps={{
                                        showSearch: true,
                                        allowClear: true,
                                        dropdownStyle: { maxHeight: 400, overflow: 'auto' },
                                        treeData,
                                        treeDefaultExpandAll: true,
                                        filterTreeNode: filterTreeNodeFn,
                                        multiple: false
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Field
                                    name="name"
                                    label="Name"
                                    {...formItemLayout}
                                    component={TextField}
                                    placeholder="Category name"
                                    validate={[required]}
                                />
                            </Col>
                        </Row>
                    </section>
                    <section className="action-panel">
                        <Button type="primary" htmlType="submit" loading={submitting} icon="save">Save</Button>
                    </section>
                </form>
            </Card>
        );
    }
}

// tslint:disable-next-line:no-any
const F: any = reduxForm<FormData>({
    form: 'createOrEditCategory',
    enableReinitialize: true,
    asyncValidate: validateIDAsync,
})(CreateOrEditCategory);
export default connect(mapStateToProps, mapDispatchToProps)(F);



// WEBPACK FOOTER //
// ./src/categories/forms/CreateOrEditCategory.tsx